<template>
  <span v-on:click="toggle" class="icon has-text-grey-darker poly-cursor-pointer">
    <i v-if="track.liked" class="mdi mdi-18px mdi-heart"></i>
    <i v-else class="mdi mdi-18px mdi-heart-outline has-text-grey-light"></i>
  </span>
</template>

<script>
  import gql from 'graphql-tag'

  export default {
    name: 'LikeTrack',
    props: {
      track: {
        type: Object,
        required: true
      }
    },
    methods: {
      toggle: function() {
        if (this.track.liked) {
          this.$apollo.mutate({
            mutation: require('@/graphql/mutations/UnlikesTrack.gql'),
            variables: { trackId: this.track.id },
            update: (store, { data: { unlikesTrack } }) => {
              this.updateTrack(store, unlikesTrack)
            }
          }).catch((error) => {
            console.warn(`Error trying to unlikes track with id ${this.track.id}: ${error}`)
          })
        } else {
          this.$apollo.mutate({
            mutation: require('@/graphql/mutations/LikesTrack.gql'),
            variables: { trackId: this.track.id },
            update: (store, { data: { likesTrack } }) => {
              this.updateTrack(store, likesTrack)
            }
          }).catch((error) => {
            console.warn(`Error trying to likes track with id ${this.track.id}: ${error}`)
          })
        }
      },
      updateTrack: function(store, track) {
        store.writeFragment({
          id: `Track:${track.id}`,
          fragment: gql`
            fragment UpdateLiked on Track {
              liked
            }
          `,
          data: {
            liked: track.liked,
            __typename: 'Track',
          }
        })

        this.track.liked = track.liked
      }
    }
  }
</script>
